document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('#showMoreDescriptionButton');

  buttons.forEach(btn => {
    const targetId = btn.getAttribute('data-target');
    const content = document.getElementById(targetId);

    let isExpanded = false;

    function updateState() {
      if (window.innerWidth <= 768) {
        if (!isExpanded) {
          content.classList.add('collapsed');
          btn.textContent = 'Show more';
          btn.style.display = 'block';
        } else {
          content.classList.remove('collapsed');
          btn.textContent = 'Show less';
        }
      } else {
        content.classList.remove('collapsed');
        btn.style.display = 'none';
      }
    }

    btn.addEventListener('click', () => {
      isExpanded = !isExpanded;
      updateState();
    });

    window.addEventListener('resize', updateState);

    updateState();
  });
});